import { UserCheck, UserRoundCheck, UserRoundX, Users } from "lucide-react";
import type { PartyStats } from "@/lib/party.api";
import { PartyKpiCard } from "../../party/components/PartyKpiCard";

interface PartyStatsGridProps {
  stats?: PartyStats;
  loading: boolean;
}

export function PartyStatsGrid({ stats, loading }: PartyStatsGridProps) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <PartyKpiCard
        label="Total parties"
        value={loading ? "..." : String(stats?.total ?? 0)}
        detail={`${stats?.active ?? 0} actives`}
        icon={Users}
        tone="gold"
      />
      <PartyKpiCard
        label="Clients"
        value={loading ? "..." : String(stats?.clients ?? 0)}
        detail="Peuvent recevoir proformas et factures"
        icon={UserRoundCheck}
        tone="success"
      />
      <PartyKpiCard
        label="Référents"
        value={loading ? "..." : String(stats?.referrers ?? 0)}
        detail={`${stats?.clientAndReferrer ?? 0} aussi clients`}
        icon={UserCheck}
        tone="neutral"
      />
      <PartyKpiCard
        label="Désactivées"
        value={loading ? "..." : String(stats?.inactive ?? 0)}
        detail="Masquées des nouveaux flux"
        icon={UserRoundX}
        tone={stats?.inactive ? "danger" : "neutral"}
      />
    </div>
  );
}
